<template>
    <transition name="appmenu">
        <div class="app-menu h-full fixed pin-x pin-y z-30 md:z-50" v-if="show">
            <div class="app-menu-bg"></div>
            <div class="app-menu-inner h-full relative px-4"
                 @click="onClickBackground">
                <div class="app-menu-title mx-auto py-10">
                    <h2 class="text-center text-blue" v-text="title"></h2>
                </div>

                <div class="app-menu-apps flex items-center justify-center rounded-lg bg-white shadow-lg mx-auto max-w-sm"
                     ref="apps">
                    <div class="w-full flex flex-wrap lg:flex-wrap mx-auto pt-8 pb-4">
                        <app-icon
                                v-for="app in apps"
                                :key="app.label"
                                :click="app.click"
                                :route="app.route"
                                :label="trans(app.trans)"
                                :icon="app.icon"
                                :badge="app.badge"
                                @navigate="onNavigate"
                        >
                        </app-icon>
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['title', 'apps'],

        data() {
            return {
                show: false
            }
        },

        methods: {
            toggle() {
                this.show = !this.show
            },

            close() {
                this.show = false
            },

            open() {
                this.show = true
                this.$root.refs.navigation[0].close()
            },

            onClickBackground(event) {
                if (this.$refs.apps && !this.$refs.apps.contains(event.target)) {
                    this.toggle()
                }
            },

            onNavigate() {
                this.close();
            }
        },

        watch: {
            $route(to, from) {
                this.close();
            }
        },
    }
</script>

<style lang="scss">
    .app-menu {
        backdrop-filter: blur(10px);
    }

    .app-menu-bg {
        background-image: url('../assets/background.jpg');
        background-size: cover;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: 0.9;

        &:after {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.9);
        }
    }

    .app-menu-inner {
        z-index: 2;
    }

    .app-menu-apps {
        transition-duration: .4s;
        transition-property: opacity, transform;
        transition-timing-function: ease;
        transform: scale(1)
    }

    .app-menu-title {
        transition-duration: 1s;
        transition-property: opacity;
        transition-timing-function: ease;
        transition-delay: .5s;
    }

    .appmenu-enter-active,
    .appmenu-leave-active {
        transition-duration: .2s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .appmenu-enter,
    .appmenu-leave-active {
        opacity: 0;

        .app-menu-apps {
            opacity: 0;
            transform: scale(0.8)
        }

        .app-menu-title {
            opacity: 0;
        }
    }
</style>